import { apiAxios } from "./apiConfig";

export interface GroupUser {
  id: string;
  first_name: string;
  last_name: string;
}

export interface GroupCreator {
  name: string;
}

export interface Group {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string | null;
  user: GroupUser[];
  creator: GroupCreator;
}

export interface GroupListResponse {
  status: boolean;
  data: Group[];
}

export const getGroupList = async (): Promise<GroupListResponse> => {
  const response = await apiAxios.get<GroupListResponse>("/group/list");
  return response.data;
};

export interface GroupUserPayload {
  userId: string;
  isActive: boolean;
}

export interface CreateGroupPayload {
  name: string;
  users: GroupUserPayload[];
}

export interface UpdateGroupPayload {
  name: string;
  isActive: boolean;
  users: GroupUserPayload[];
}

export const createGroup = async (payload: CreateGroupPayload) => {
  const res = await apiAxios.post("/group/create", payload);
  return res.data;
};

export const updateGroup = async (
  groupId: string,
  payload: UpdateGroupPayload,
) => {
  const res = await apiAxios.put(`/group/${groupId}`, payload);
  return res.data;
};
